import apiEndpoints from '@src/lib/apiEndpoints';

import apiRequest from './api';

export interface DownloadSheetProps {
  program_id: string;
  activity_id: string;
  instructor_id: string;
}

export const downloadSheet = async (params: DownloadSheetProps) => {
  return apiRequest({
    method: 'get',
    url: `${apiEndpoints.DOWNLOAD_SHEET}`,
    config: { params, responseType: 'blob' },
  });
};

export const downloadAllProgramSheet = async (params: { program_id: string }) => {
  return apiRequest({
    method: 'get',
    url: `${apiEndpoints.ALL_ATTENDANCE_SHEETS}`,
    config: { params, responseType: 'blob' },
  });
};
